import React from 'react';
import { format, isToday } from 'date-fns';

const CalendarDay = ({ 
  day, idx, isBlocked, isPastDate, isSelectedStart, 
  isSelectedEnd, isBetween, isSelectingEndDate, onClick 
}) => {
  // Hotel-style: Allow clicking a blocked date ONLY if we are selecting an end date.
  // This allows the user to click a check-out day that is also another guest's check-in day.
  const isDisabled = (isBlocked && !isSelectingEndDate) || isPastDate;
  const isSelected = isSelectedStart || isSelectedEnd;

  return (
    <button
      disabled={isDisabled}
      type="button"
      onClick={onClick}
      style={{ gridColumnStart: idx === 0 ? day.getDay() + 1 : 'auto' }}
      className={`
        h-16 md:h-24 relative flex flex-col items-center justify-center transition-all duration-200 border-r border-b border-brand-olive/5
        ${isDisabled ? 'bg-gray-50/50 cursor-not-allowed text-brand-olive/20' : 'hover:bg-brand-olive/5 cursor-pointer text-brand-olive'}
        ${isSelected ? 'bg-brand-olive !text-white z-10 shadow-lg scale-[1.02]' : 'bg-white'}
        ${isBetween ? 'bg-brand-olive/[0.08] !text-brand-olive font-bold' : ''}
      `}
    >
      <span className={`text-base md:text-xl font-sans font-bold transition-transform duration-300 ${isSelected ? 'scale-110' : ''} ${isToday(day) && !isSelected ? 'text-brand-olive underline decoration-2 underline-offset-4' : ''}`}>
        {format(day, 'd')}
      </span>
      
      {isBlocked && !isPastDate && (
        <span className="absolute inset-0 flex items-center justify-center text-brand-olive/10 text-3xl font-light pointer-events-none">✕</span>
      )}

      {/* Enhanced Visual Indicator for the "In-Between" dates */}
      {isBetween && (
        <div className="absolute bottom-3 flex flex-col items-center">
          <div className="w-2.5 h-2.5 rounded-full bg-brand-olive/60 animate-pulse shadow-sm" />
          <div className="w-8 h-[2px] bg-brand-olive/20 mt-1 rounded-full" />
        </div>
      )}

      {/* Start/End Labeling for clarity */}
      {isSelectedStart && !isSelectedEnd && (
        <span className="absolute top-2 text-[8px] font-black uppercase tracking-tighter opacity-60">Check-In</span>
      )}
      {isSelectedEnd && (
        <span className="absolute top-2 text-[8px] font-black uppercase tracking-tighter opacity-60">Check-Out</span>
      )}
    </button>
  );
};

// Use memo to prevent re-render if props haven't changed
export default React.memo(CalendarDay, (prev, next) => {
  return (
    prev.isSelectedStart === next.isSelectedStart &&
    prev.isSelectedEnd === next.isSelectedEnd &&
    prev.isBetween === next.isBetween &&
    prev.isBlocked === next.isBlocked &&
    prev.isSelectingEndDate === next.isSelectingEndDate &&
    prev.day.getTime() === next.day.getTime()
  );
});